import React, { useState } from 'react';
import { getOperarioNombre } from '../utils/helpers';

const OperationStartForm = ({ operarios, operaciones, onStartOperation }) => {
  const [selectedOperarioId, setSelectedOperarioId] = useState('');
  const [selectedPendingOperationId, setSelectedPendingOperationId] = useState('');
  const [message, setMessage] = useState('');

  const pendingOperations = operaciones.filter(op => op.estado === 'pendiente');

  const handleStart = () => {
    if (!selectedOperarioId || !selectedPendingOperationId) {
      setMessage('Por favor, selecciona un operario y una operación pendiente.');
      return;
    }
    onStartOperation({ operarioId: selectedOperarioId, pendingOperationId: selectedPendingOperationId });
    const assignedOp = pendingOperations.find(op => op.id === selectedPendingOperationId);
    setMessage(`Operación ${assignedOp ? assignedOp.producto : ''} asignada a ${getOperarioNombre(selectedOperarioId, operarios)} e iniciada.`);
    setSelectedOperarioId('');
    setSelectedPendingOperationId('');
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md mx-auto transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Asignar e Iniciar Operación Pendiente</h2>

      <div className="mb-4">
        <label htmlFor="operario-select" className="block text-gray-700 text-base font-medium mb-2">Selecciona Operario:</label>
        <select
          id="operario-select"
          value={selectedOperarioId}
          onChange={(e) => setSelectedOperarioId(e.target.value)}
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-black text-base transition"
        >
          <option value="">-- Selecciona un operario --</option>
          {operarios.map(op => (
            <option key={op.id} value={op.id}>{op.nombre}</option>
          ))}
        </select>
      </div>

      <div className="mb-6">
        <label htmlFor="pending-operation-select" className="block text-gray-700 text-base font-medium mb-2">Selecciona Operación Pendiente:</label>
        <select
          id="pending-operation-select"
          value={selectedPendingOperationId}
          onChange={(e) => setSelectedPendingOperationId(e.target.value)}
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-black text-base transition"
        >
          <option value="">-- Selecciona una operación pendiente --</option>
          {pendingOperations.map(op => (
            <option key={op.id} value={op.id}>{op.producto}</option>
          ))}
        </select>
      </div>

      <button
        onClick={handleStart}
        className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold text-lg"
      >
        Asignar y Iniciar Operación
      </button>
      {message && (
        <p className="mt-4 text-center text-sm text-gray-600">{message}</p>
      )}
    </div>
  );
};

export default OperationStartForm;